import axios from 'axios'

import * as actions from "./index"

export function fetchSettings() {
  return function (dispatch) {
    dispatch({type: actions.SETTINGS_FETCH.PENDING});
    axios.get("/settings")
      .then((response) => {
        dispatch({type: actions.SETTINGS_FETCH.SUCCESS, payload: response.data})
      })
      .catch((err) => {
        dispatch({type: actions.SETTINGS_FETCH.ERROR, payload: err})
      })
  }
}

export function updateSettings() {
  return function (dispatch) {
    dispatch({type: actions.SETTINGS_UPDATE.PENDING});
    axios.post("/settings", {})
      .then((response) => {
        dispatch({type: actions.SETTINGS_UPDATE.SUCCESS, payload: response.data})
      })
      .catch((err) => {
        dispatch({type: actions.SETTINGS_UPDATE.ERROR, payload: err})
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/settingsActions.js